import { Controller } from "@hotwired/stimulus"

// One permission card on the role form: keeps the "checked / total" badge in
// sync and provides the enable-all / disable-all bulk actions (skipping
// disabled, always-on permissions).
//
// A `restriction` target is a checkbox that TAKES access away (e.g. the capacity
// board's kiosk lock-out). It counts towards the badge and is set by hand like any
// other row, but the bulk actions leave it alone: sweeping a section on to hand out
// a grant must never switch a lock-out on as a side effect.
export default class extends Controller {
  static targets = ["checkbox", "count", "restriction"]

  connect() {
    this.refresh()
  }

  enableAll() {
    this.setAll(true)
  }

  disableAll() {
    this.setAll(false)
  }

  refresh() {
    if (!this.hasCountTarget) return

    const checked = this.checkboxTargets.filter((box) => box.checked).length
    this.countTarget.textContent = `${checked} / ${this.checkboxTargets.length}`
  }

  setAll(value) {
    this.checkboxTargets.forEach((box) => {
      if (box.disabled || this.restrictionTargets.includes(box)) return
      box.checked = value
    })
    this.refresh()
  }
}
